import { Box, chakra, Flex, Text } from '@chakra-ui/react';
import React from 'react';

import { route } from 'nextjs-routes';

interface Props {
  isCollapsed?: boolean;
  onClick?: (event: React.SyntheticEvent) => void;
  className?: string;
}

const NetworkLogo = ({ isCollapsed, onClick, className }: Props) => {
  const iconDisplay = {
    base: 'none',
    lg: isCollapsed === false ? 'none' : 'flex',
    xl: isCollapsed ? 'flex' : 'none',
  };
  const wordmarkDisplay = {
    base: 'flex',
    lg: isCollapsed === false ? 'flex' : 'none',
    xl: isCollapsed ? 'none' : 'flex',
  };

  const mark = (
    <Box position="relative" boxSize="30px" flexShrink={ 0 } aria-hidden="true">
      <Box position="absolute" inset="2px 8px 8px 2px" bg="blue.700" borderRadius="8px" transform="rotate(-8deg)"/>
      <Box
        position="absolute"
        inset="9px 2px 2px 9px"
        bg="orange.500"
        borderRadius="7px"
        transform="rotate(8deg)"
        boxShadow="0 2px 8px rgba(233, 120, 23, .28)"
      />
    </Box>
  );

  return (
    <chakra.a
      className={ className }
      href={ route({ pathname: '/' }) }
      display="inline-flex"
      alignItems="center"
      flexShrink={ 0 }
      onClick={ onClick }
      aria-label="رفتن به صفحه اصلی کاوشگر صبانفت"
    >
      <Flex display={ iconDisplay }>{ mark }</Flex>
      <Flex display={ wordmarkDisplay } alignItems="center" gap={ 2 } dir="rtl">
        { mark }
        <Box lineHeight="1">
          <Text color="blue.800" fontSize="20px" fontWeight="700" letterSpacing="-.4px">صبانفت</Text>
          <Text color="orange.600" fontSize="9px" fontWeight="600" mt="3px">کاوشگر زنجیره صبا</Text>
        </Box>
      </Flex>
    </chakra.a>
  );
};

export default React.memo(chakra(NetworkLogo));
